import React, { Suspense } from 'react';
import './Dash.css';
import {
    Route,
    Routes
} from "react-router-dom";
const ShowDash = React.lazy(() => import('../dashpages/public/ShowDash'));
const SlugDisplay = React.lazy(() => import('../dashpages/public/SlugDisplay'));
const SlugDash = React.lazy(() => import ('../dashpages/public/SlugDash'));
const KaraokeDisplay = React.lazy(() => import('../dashpages/public/KaroakeDisplay'));
const KaraokeDash = React.lazy(() => import('../dashpages/public/KaraokeDash'));
const ShowDisplay = React.lazy(() => import('../dashpages/public/ShowDisplay'));
const ShowDisplayB = React.lazy(()=> import('../dashpages/public/ShowDisplayB'));
const ProfilePanelArtist = React.lazy(() => import('../dashpages/artist/ProfilePanelArtist'));
const SetlistPanel = React.lazy(() => import('../dashpages/setlist/SetlistPanel'));
const CreateSetlistForm = React.lazy(() => import('../forms/CreateSetlistForm'));
const LoginForm = React.lazy(() => import('../forms/LoginForm'));
const Logout = React.lazy(() => import('../dashpages/Logout'));
const CreateUserForm = React.lazy(() => import('../forms/CreateUserForm'));
const CreateArtistForm = React.lazy(() => import('../forms/CreateArtistForm'));
const EditProfileForm = React.lazy(() => import('../forms/EditProfileForm'));
const Setlist = React.lazy(() => import('../dashpages/setlist/Setlist'));
const SongBank = React.lazy(() => import('../dashpages/songs/SongBank'));
const SongPanel = React.lazy(() => import('../dashpages/songs/SongPanel'));
const LiveDash = React.lazy(() => import('../dashpages/livedash/LiveDash'));
const CreateShowForm = React.lazy(() => import('../forms/CreateShowForm'));
const Home = React.lazy(() => import('../dashpages/public/Home'));
const ErrorPage = React.lazy(() => import('../errorpages/common'));
const Popups = React.lazy(()=> import('../dashpages/public/Popups'));
const Features = React.lazy(() => import('../dashpages/public/Features'));
const VerifyEmail = React.lazy(() => import('../dashpages/verifyemail/VerifyEmail'))
const RegisterSplash = React.lazy(() => import('../dashpages/RegisterSplash'))
const ResetPasswordSend = React.lazy(() => import('../ResetPasswordSend'))
const ResetPassword = React.lazy(() => import('../ResetPassword'))
const Terms = React.lazy(() => import('../dashpages/public/Terms'))
const Privacy = React.lazy(() => import('../dashpages/public/Privacy'))
const HowTo = React.lazy(()=> import('../dashpages/public/HowTo'))


//const NotFoundRedirect = ErrorRedirect(404)
class Dash extends React.Component {

    render() {
        return (

            <div className="dash min-w-[100vw] sm:min-w-[80vw] max-w-[100vw]">
                <Suspense fallback={<div id="loading" className="w-50 h-50"></div>}>
                    <Routes>
                        <Route path="/artist-profile" element={<ProfilePanelArtist />} />
                        <Route path="/setlists" element={<SetlistPanel />} />
                        <Route path="/create-setlist" element={<CreateSetlistForm />} />
                        <Route path="/login" element={<LoginForm />} />
                        <Route path="/logout" element={<Logout />} />
                        <Route path="/register" element={<CreateUserForm />} />
                        <Route path="/register-artist" element={<CreateArtistForm />} />
                        <Route path="/edit-profile" element={<EditProfileForm />} />
                        <Route path="/setlist/:setlistId" element={<Setlist />} />
                        <Route path="/songbank" element={<SongBank />} />
                        <Route path="/songs" element={<SongPanel />} />
                        <Route path="/live-dash" element={<LiveDash />} />
                        <Route path="/go-live" element={<CreateShowForm />} />
                        <Route path="/" element={<Home />} exact />
                        <Route path="/show/:showId" element={<ShowDash />} />
                        <Route path="/error/:errorId" element={<ErrorPage />} />
                        <Route path="/display/:showId" element={<ShowDisplay />} />
                        <Route path="/displayb/:showId" element={<ShowDisplayB />} />
                        <Route path="/karaoke/:showId" element={<KaraokeDisplay />} />
                        <Route path="/karaoke-dash/:showId" element={<KaraokeDash />} />
                        <Route path="/popups/:showId" element={<Popups/>}/>
                        <Route path="/features" element={<Features />} />
                        <Route path="/register-splash" element={<RegisterSplash />} />
                        <Route path="/reset-password-send" element={<ResetPasswordSend />} />
                        <Route path="/reset-password/:uid/:token" element={<ResetPassword />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/howto" element={<HowTo/>}/>
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/verify/:uid/:token" element={<VerifyEmail />} exact />
                        <Route path="/display-slug/:slug" element={<SlugDisplay />} exact />
                        <Route path="/:slug" element={<SlugDash />} exact />
                        
                    </Routes>
                </Suspense>
            </div>
        );
    }
}

export default Dash;